module.exports = __webpack_public_path__ + "img/Philippines.7478a9ac.svg";